import { useEffect, useState } from 'react';

export default function TopBar() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="absolute top-0 left-0 right-0 z-50 flex items-center justify-between px-8 py-5 bg-gradient-to-b from-[#0a0e1a] to-transparent">
      <div className="flex items-center gap-4">
        <img 
          src="https://static.readdy.ai/image/7e79f97e364cc868c9b36c9d877389d3/a4c5368e774afebc916ab749fd87fa13.png" 
          alt="Jumborca" 
          className="h-10 w-auto"
        />
        <div className="border-l border-gray-700 pl-4">
          <h1 className="text-xl font-semibold text-white tracking-wide">Global Data Protection Status</h1>
          <p className="text-xs text-gray-400 mt-0.5">Real-time visibility of protected data across global regions</p>
        </div>
      </div>
      
      <div className="flex items-center gap-6">
        <div className="text-right">
          <div className="text-sm text-gray-400">China Time (UTC+8)</div>
          <div className="text-lg font-mono text-white">{currentTime.toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai', hour12: false })}</div>
        </div>
        <div className="flex items-center gap-2 bg-emerald-500/10 px-4 py-2 rounded-full border border-emerald-500/30">
          <div className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></div>
          <span className="text-sm text-emerald-400 font-medium">Normal</span>
        </div>
      </div>
    </div>
  );
}